export const Play = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5976 11.7C21.5982 11.9742 21.5318 12.2439 21.4046 12.4829C21.2775 12.7219 21.0941 12.9221 20.8722 13.0639L7.11906 21.9622C6.88719 22.1124 6.62162 22.1943 6.34977 22.1997C6.07793 22.205 5.80967 22.1335 5.5727 21.9925C5.33798 21.8537 5.14246 21.6513 5.00624 21.4061C4.87001 21.1608 4.798 20.8817 4.79761 20.5973V2.80264C4.798 2.51823 4.87001 2.23906 5.00624 1.99384C5.14246 1.74863 5.33798 1.54621 5.5727 1.40742C5.80967 1.26643 6.07793 1.1949 6.34977 1.20023C6.62162 1.20555 6.88719 1.28753 7.11906 1.4377L20.8722 10.336C21.0941 10.4778 21.2775 10.678 21.4046 10.917C21.5318 11.156 21.5982 11.4257 21.5976 11.7Z"
        fill="white"
      />
    </svg>
  )
}
